import styled from 'styled-components';
import { Box } from 'src/viewLayer/components/DesignSystem';

export const DescriptionContainer = styled(Box)`
  margin: 0 auto;
  width: 18.75rem;
`;
